import { useTranslation } from "react-i18next";
import { classNames, constraint } from "../../helpers";

type ProgressBarProps = {
  numberOfLevels: number;
  finishedLevels?: number;
  title: string;
  showDot?: boolean;
  dotColorClass?: string;
  progressBarColorClass: string;
};

export default function KhetmaProgress(props: ProgressBarProps) {
  let { numberOfLevels, finishedLevels = 0 } = props;
  finishedLevels = constraint(finishedLevels, 0, numberOfLevels);

  return (
    <div className="flex flex-row gap-3 items-center  ">
      <div className="flex flex-col gap-3 w-full">
        <LevelHeader {...props} />
        <ProgressBar {...props} />
      </div>
    </div>
  );
}

const ProgressBar = (props: ProgressBarProps) => {
  const { numberOfLevels, finishedLevels = 0, progressBarColorClass } = props;
  const remainingLevels = (100 * finishedLevels) / numberOfLevels;
  return (
    <div className="flex flex-row gap-1">
      <div className="w-full bg-[#D1D5DB] rounded-full h-1.5 ">
        <div
          className={classNames(" h-1.5 rounded-full", progressBarColorClass)}
          style={{
            width: remainingLevels + "%",
            maxWidth: "100%",
          }}
        ></div>
      </div>
    </div>
  );
};

const LevelHeader = (props: ProgressBarProps) => {
  const {
    numberOfLevels,
    finishedLevels = 0,
    title,
    showDot,
    dotColorClass,
  } = props;
  const { t, i18n } = useTranslation("", {
    keyPrefix: "page.candidate.dashboard.levelProgress",
  });

  const calculateDotColorClass = () => {
    if (numberOfLevels - finishedLevels === 0) return "bg-green-500";
    if (numberOfLevels - finishedLevels === 1) return "bg-orange-500";
    return "bg-red-500";
  };

  return (
    <div className="flex flex-row gap-3 justify-between">
      <div className="flex items-center gap-2">
        {showDot && (
          <span
            className={classNames(
              "w-2 h-2  rounded-full",
              dotColorClass || calculateDotColorClass()
            )}
          ></span>
        )}
        <p className="text-xs  font-medium text-gray-600">{t(title)}</p>
      </div>
      <div className="flex flex-row font-medium">
        <div className=" text-gray-400 flex items-end">
          <span className="text-xs ">{numberOfLevels}</span>
        </div>
        <div className="text-xs text-gray-400">{`${
          i18n.dir() === "rtl" ? "/" : "\\"
        }${finishedLevels}`}</div>
      </div>
    </div>
  );
};
